import produce from 'immer';

const INITIAL_STATE = {
  list: [],
  loading: false,
};

export default function menuProject(state = INITIAL_STATE, action) {
  switch (action.type) {
    case '@menu/projects/INDEX_REQUEST':
      return produce(state, draft => {
        draft.loading = true;
      });

    case '@menu/projects/INDEX_SUCCESS':
      return produce(state, draft => {
        draft.loading = false;
        draft.list = action.payload.data;
      });

    case '@menu/projects/INDEX_FAILURE':
      return produce(state, draft => {
        draft.loading = false;
      });

    default:
      return state;
  }
}
